/* eslint-disable import/no-extraneous-dependencies */
import React, { Component } from 'react';
import { Modal, Label } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import $ from 'jquery';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { v4 as uuidv4 } from 'uuid';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import Loader from '../Loader/Loader';
import api from '../../api';
import SecurityDetailModal from './SecurityDetailModal';
import WithRouter from '../Extensions/WithRouter';

class ComponentVersionModal extends Component {
  constructor(props) {
    super(props);
    this.barChart = null;
    this.isDragging = false;
    this.isComponentMounted = false;
    this.state = {
      isOpenCVM: props.isOpenCVM,
      idReport: props.idReport || null,
      currentComponentVersion: props.currentComponentVersion || null,
      componentVersionType: props.componentVersionType,
      isLoading: false,
      versionList: [],
      labelList: [],
      activeIndex: null,
      isOpenMSD: false,
      cveData: {},
      selectedCode: '',
      detailInfo: [],
      //maxValue: null,
      currentIndex: null,
      latestIndex: null,
    };
    this.handleSecurityDetailModal = this.handleSecurityDetailModal.bind(this);
    this.handleMSDClose = this.handleMSDClose.bind(this);
    this.handleVersionChange = this.handleVersionChange.bind(this);
    this.revertVersion = this.revertVersion.bind(this);
    this.updateSecurityPoint = this.updateSecurityPoint.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.isComponentMounted = true;
    $(document).on('mouseover', '.component_versions_popup .component_versions_table td', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    $(document).on('mouseover', '.setting_popup .setting_popup_header .popup_name span', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { activeIndex, componentVersionType } = this.state;
    const { isOpenCVM, componentName } = this.props;
    if (prevState.activeIndex !== activeIndex) {
      if (activeIndex) {
        this.renderDetail(activeIndex);
      }
    }

    if (prevProps.isOpenCVM !== isOpenCVM) {
      if (isOpenCVM) {
        this.setState({
          isOpenCVM,
        });
        this.isComponentMounted = true;
        if (componentVersionType === 'detail') {
          this.getComponentVersionRisk(componentName);
        } else {
          this.getfileComponentVersionRisk(componentName);
        }
      } else {
        if (this.barChart) {
          this.barChart.destroy();
          this.barChart = null;
        }
        this.setState({
          isOpenCVM,
          versionList: [],
          labelList: [],
          detailInfo: [],
          activeIndex: null,
          isLoading: false,
          //maxValue: null,
          currentIndex: null,
          latestIndex: null,
        }, () => {
          this.isComponentMounted = false;
        });
      }
    }
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
    if (this.barChart) {
      this.barChart.destroy();
      this.barChart = null;
    }
  }

  handleVersionChange(e) {
    const { activeIndex } = this.state;
    if (e.target.value === activeIndex) {
      return;
    }
    this.setState({
      activeIndex: e.target.value,
    });
  }

  handleSecurityDetailModal(e, value) {
    const data = {
      security_name: value,
    };
    api
      .getComponentSecurityDetail(data)
      .then((response) => {
        this.setState({
          cveData: response.response,
          selectedCode: value,
          isOpenMSD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleMSDClose() {
    this.setState({
      isOpenMSD: false,
    });
  }

  findMaxCount = (data) => {
    if (data.length !== 0) {
      return Math.max(...data.map((o) => {
        return o.security_count.total;
      }));
    }
    return null;
  };

  resetZoom = () => {
    if (this.barChart) {
      this.barChart.resetZoom();
    }
  };

  revertVersion = () => {
    const { latestIndex, currentIndex, versionList } = this.state;
    if (currentIndex) {
      return this.setState({
        activeIndex: versionList[currentIndex].component_version,
      });
    }

    if (latestIndex) {
      return this.setState({
        activeIndex: versionList[latestIndex].component_version,
      });
    }
  };

  updateSecurityPoint = (version) => {
    const { activeIndex } = this.state;

    if (activeIndex === version) {
      return;
    }

    this.setState({
      activeIndex: version,
    });
  };

  //detail
  getComponentVersionRisk = (componentName) => {
    const { idReport, currentComponentVersion } = this.state;
    const obj = {
      component_name: componentName,
    };
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getComponentVersionRisk(obj, idReport)
        .then((response) => {
          const data = response.response;
          //const maxCount = this.findMaxCount(data);
          const currentIndex = data.findIndex((item) => {
            return item.component_version === currentComponentVersion;
          });

          const labelList = data.map((item, index) => {
            return {
              key: index,
              text: item.component_version,
              value: item.component_version,
            };
          });

          if (data.length !== 0) {
            this.setState({
              isLoading: false,
              versionList: data,
              labelList,
              //maxValue: maxCount,
              currentIndex: currentIndex < 0 ? null : currentIndex,
              latestIndex: currentIndex < 0 ? data.length - 1 : null,
            }, () => {
              if (this.isComponentMounted) {
                this.drawChart();
              }
            });
          } else {
            this.setState({
              isLoading: false,
              versionList: data,
              labelList: [],
              //maxValue: maxCount,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  };

  //List
  getfileComponentVersionRisk = (componentName) => {
    const { currentComponentVersion } = this.state;
    const obj = {
      component_name: componentName,
    };
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getfileComponentVersionRisk(obj)
        .then((response) => {
          const data = response.response;
          //const maxCount = this.findMaxCount(data);
          const currentIndex = data.findIndex((item) => {
            return item.component_version === currentComponentVersion;
          });

          const labelList = data.map((item, index) => {
            return {
              key: index,
              text: item.component_version,
              value: item.component_version,
            };
          });

          if (data.length !== 0) {
            this.setState({
              isLoading: false,
              versionList: data,
              labelList,
              //maxValue: maxCount,
              currentIndex: currentIndex < 0 ? null : currentIndex,
              latestIndex: currentIndex < 0 ? data.length - 1 : null,
            }, () => {
              if (this.isComponentMounted) {
                this.drawChart();
              }
            });
          } else {
            this.setState({
              isLoading: false,
              versionList: data,
              labelList: [],
              //maxValue: maxCount,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  };

  onMouseDownElement = (e) => {
    if (e.target.classList[0] !== 'version_list' && e.preventDefault) {
      return e.preventDefault();
    }
  };

  drawChart() {
    if (this.isComponentMounted && this.barChart) {
      this.barChart.destroy();
      this.barChart = null;
    }

    const {
      versionList, currentIndex, latestIndex, activeIndex
    } = this.state;
    const { translate } = this.props;

    const chartLabel = [];
    const criticalData = [];
    const highData = [];
    const mediumData = [];
    const lowData = [];
    const maxCount = this.findMaxCount(versionList);
    let size;
    if (maxCount < 5) {
      size = 5;
    } else {
      size = Math.floor(maxCount / 5);
      size = Math.ceil(size / 5) * 5;
    }

    versionList.map((item) => {
      chartLabel.push(item.component_version);
      criticalData.push(item.security_count.critical);
      highData.push(item.security_count.high);
      mediumData.push(item.security_count.medium);
      lowData.push(item.security_count.low);
      return null;
    });

    const startVersion = chartLabel[0];
    const endVersion = chartLabel[chartLabel.length - 1];

    const ctx = this.securityBarChart.getContext('2d');

    const barChartData = {
      labels: chartLabel,
      datasets: [
        {
          label: translate('chart.title.low'),
          backgroundColor: '#ffde00',
          borderColor: '#ffde00',
          borderWidth: 1,
          data: lowData,
        },
        {
          label: translate('chart.title.medium'),
          backgroundColor: '#ffae00',
          borderColor: '#ffae00',
          borderWidth: 1,
          data: mediumData,
        },
        {
          label: translate('chart.title.high'),
          backgroundColor: '#ff7d00',
          borderColor: '#ff7d00',
          borderWidth: 1,
          data: highData,
        },
        {
          label: translate('chart.title.critical'),
          backgroundColor: '#ff440c',
          borderColor: '#ff440c',
          borderWidth: 1,
          data: criticalData,
        },
      ],
    };

    const scales = {
      x: {
        type: 'category',
        min: startVersion,
        max: endVersion,
        stacked: true,
        ticks: {
          autoSkip: true,
          autoSkipPadding: 10,
          color: '#afafaf',
          font: {
            size: 9,
          }
        },
      },
      y: {
        type: 'linear',
        stacked: true,
        min: 0,
        max: Math.ceil(maxCount / 10) * 10 || 0,
        title: {
          display: true,
          text: translate('chart.title.vulnerabilities'),
          font: {
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
          },
        },
        ticks: {
          beginAtZero: true,
          stepSize: size,
        },
      }
    };

    const config = {
      type: 'bar',
      data: barChartData,
      barThickness: 'flex',
      options: {
        legend: {
          display: true,
        },
        interaction: {
          mode: 'index',
        },
        scales,
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: 'x',
              modifierKey: 'shift',
            },
            zoom: {
              drag: {
                enabled: true,
                borderColor: '#7434fe',
                borderWidth: 0.5,
                backgroundColor: '#d6d2ff',
              },
              mode: 'x',
            }
          }
        },
        transitions: {
          zoom: {
            animation: {
              duration: 100
            }
          }
        },
        onClick: (e) => {
          const activePoints = e.chart.tooltip.dataPoints;
          if (activePoints.length !== 0) {
            const selectedLabel = activePoints[0].label;
            this.updateSecurityPoint(selectedLabel);
          }
        },
      },
    };

    Chart.register(zoomPlugin);
    this.barChart = new Chart(ctx, config);

    if (this.barChart && versionList.length !== 0 && !activeIndex) {
      if (currentIndex) {
        return this.setState({
          activeIndex: versionList[currentIndex].component_version,
        });
      }

      if (latestIndex) {
        return this.setState({
          activeIndex: versionList[latestIndex].component_version,
        });
      }
    }
  }

  closeModal() {
    const { closeModal } = this.props;
    if (this.isDragging) {
      this.isDragging = false;
      return;
    }
    closeModal();
  }

  renderDetail = (version) => {
    const { versionList } = this.state;
    const selectedIndex = versionList.findIndex((item) => {
      return item.component_version === version;
    });

    this.setState({
      detailInfo: versionList[selectedIndex].securities,
    });
  };

  /*
  renderSecurityChart = (obj) => {
    const {
      critical,
      high,
      low,
      medium,
      total,
    } = obj;

    const { maxValue } = this.state;

    if (total === 0) {
      return (
        <div className="stairs">
          <div style={{ height: '1%' }} className="none" />
        </div>
      );
    }

    const currentPercentage = (total / maxValue) * 100;

    return (
      <div className="stairs">
        <div style={{ height: `${Math.round((critical / total) * currentPercentage) + Math.round((high / total) * currentPercentage) + Math.round((medium / total) * currentPercentage) + Math.round((low / total) * currentPercentage) || 0}%` }} className="red" />
        <div style={{ height: `${Math.round((high / total) * currentPercentage) + Math.round((medium / total) * currentPercentage) + Math.round((low / total) * currentPercentage) || 0}%` }} className="orange" />
        <div style={{ height: `${Math.round((medium / total) * currentPercentage) + Math.round((low / total) * currentPercentage) || 0}%` }} className="cheese" />
        <div style={{ height: `${Math.round((low / total) * currentPercentage) || 0}%` }} className="yellow" />
      </div>
    );
  };
  */
  renderDetailInfo = () => {
    const { detailInfo } = this.state;
    const { translate } = this.props;

    if (detailInfo.length === 0) {
      return null;
    }

    const totalCount = detailInfo.critical.length + detailInfo.high.length + detailInfo.medium.length + detailInfo.low.length;

    return (
      <table className="table table_type_3">
        <colgroup>
          <col style={{ width: '40%' }} />
          <col style={{ width: '25%' }} />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th>{translate('chart.title.severity')}</th>
            <th>{translate('chart.title.score')}</th>
            <th>
              {translate('chart.title.score')}
              (
              {totalCount}
              )
            </th>
          </tr>
          {
            detailInfo.critical.length !== 0
            && detailInfo.critical.map((item, i) => {
              if (i === 0) {
                return (
                  <tr key={uuidv4()}>
                    <td rowSpan={detailInfo.critical.length} className="vat">
                      {translate('chart.title.critical_uppercase')}
                    </td>
                    <td>
                      {item.score}
                    </td>
                    <td
                      //className="tac"
                      className=""
                    >
                      <div className="block bullet bullet_red">
                        <span
                          className="name has_link"
                          onClick={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                          onKeyUp={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                        >
                          {item.security_code}
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={uuidv4()}>
                  <td>
                    {item.score}
                  </td>
                  <td>
                    <div className="block bullet bullet_red">
                      <span
                        className="name has_link"
                        onClick={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                        onKeyUp={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                      >
                        {item.security_code}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })
          }
          {
            detailInfo.high.length !== 0
            && detailInfo.high.map((item, j) => {
              if (j === 0) {
                return (
                  <tr key={uuidv4()}>
                    <td rowSpan={detailInfo.high.length} className="vat">
                      {translate('chart.title.high_uppercase')}
                    </td>
                    <td>
                      {item.score}
                    </td>
                    <td>
                      <div className="block bullet bullet_orange">
                        <span
                          className="name has_link"
                          onClick={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                          onKeyUp={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                        >
                          {item.security_code}
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={uuidv4()}>
                  <td>
                    {item.score}
                  </td>
                  <td>
                    <div className="block bullet bullet_orange">
                      <span
                        className="name has_link"
                        onClick={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                        onKeyUp={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                      >
                        {item.security_code}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })
          }
          {
            detailInfo.medium.length !== 0
            && detailInfo.medium.map((item, k) => {
              if (k === 0) {
                return (
                  <tr key={uuidv4()}>
                    <td rowSpan={detailInfo.medium.length} className="vat">
                      {translate('chart.title.medium_uppercase')}
                    </td>
                    <td>
                      {item.score}
                    </td>
                    <td>
                      <div className="block bullet bullet_cheese">
                        <span
                          className="name has_link"
                          onClick={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                          onKeyUp={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                        >
                          {item.security_code}
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={uuidv4()}>
                  <td>
                    {item.score}
                  </td>
                  <td>
                    <div className="block bullet bullet_cheese">
                      <span
                        className="name has_link"
                        onClick={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                        onKeyUp={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                      >
                        {item.security_code}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })
          }
          {
            detailInfo.low.length !== 0
            && detailInfo.low.map((item, l) => {
              if (l === 0) {
                return (
                  <tr key={uuidv4()}>
                    <td rowSpan={detailInfo.low.length} className="vat">
                      {translate('chart.title.low_uppercase')}
                    </td>
                    <td>
                      {item.score}
                    </td>
                    <td>
                      <div className="block bullet bullet_yellow">
                        <span
                          className="name has_link"
                          onClick={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                          onKeyUp={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                        >
                          {item.security_code}
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={uuidv4()}>
                  <td>
                    {item.score}
                  </td>
                  <td>
                    <div className="block bullet bullet_yellow">
                      <span
                        className="name has_link"
                        onClick={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                        onKeyUp={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                      >
                        {item.security_code}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </table>
    );
  };

  render() {
    const {
      isLoading,
      isOpenCVM,
      versionList,
      activeIndex,
      cveData,
      labelList,
      currentIndex,
      latestIndex,
      isOpenMSD,
      selectedCode
    } = this.state;

    const { translate, componentName } = this.props;

    return (
      <Modal
        open={isOpenCVM}
        onClose={this.closeModal}
      >
        <div className="setting_popup_wrap">
          {
            isLoading ? (
              <div className="setting_popup default_popup component_versions_popup">
                <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                  <Loader />
                </div>
              </div>
            ) : (
              <div className="setting_popup default_popup component_versions_popup" onMouseDown={this.onMouseDownElement}>
                <div className="setting_popup_header">
                  <h2 className="popup_name">
                    <span>{translate('modal.compare_version.compare_all_versions')}</span>
                    |
                    <span>{componentName}</span>
                    <em>
                      {versionList.length}
                      {translate('modal.compare_version.versions')}
                    </em>
                  </h2>
                  <a
                    className="popup_close_button"
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    <img src={closeBtn} alt="" />
                  </a>
                </div>
                <Scrollbars
                  style={{
                    position: 'relative',
                    overflow: 'hidden',
                    height: '100%',
                  }}
                >
                  <div className="setting_popup_contnets">
                    <div className="setting_popup_content_wrap">
                      <div className="component_versions_box">
                        <div className="">
                          <div className="button_wrap">
                            <a
                              className="button revert"
                              onClick={this.resetZoom}
                              onKeyUp={this.resetZoom}
                            >
                              {translate('modal.compare_version.reset_zoom')}
                            </a>
                          </div>
                          <div
                            className="component_versions_item_wrap"
                            style={{ width: '95%' }}
                          >
                            <canvas
                              className="bar_chart"
                              ref={(ref) => {
                                this.securityBarChart = ref;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="setting_popup_content_wrap">
                      {
                        activeIndex ? (
                          <div className="title_wrap">
                            <div className="version_title">{translate('modal.compare_version.security_vuln_for_version')}</div>
                            {
                              activeIndex && currentIndex && versionList[currentIndex].component_version === activeIndex ? (
                                <Label className="version_option" horizontal>{translate('modal.compare_version.current_version')}</Label>
                              ) : null
                            }
                            {
                              activeIndex && latestIndex && versionList[latestIndex].component_version === activeIndex ? (
                                <Label className="version_option" horizontal>{translate('modal.compare_version.latest_version')}</Label>
                              ) : null
                            }
                            <select
                              onChange={this.handleVersionChange}
                              value={activeIndex}
                              className="version_list"
                            >
                              {
                                labelList.map((item) => {
                                  return (
                                    <option value={item.value} key={uuidv4()}>{item.text}</option>
                                  );
                                })
                              }
                            </select>
                            <div className="button_wrap">
                              <a
                                className="button version"
                                onClick={this.revertVersion}
                                onKeyUp={this.revertVersion}
                              >
                                {translate('modal.compare_version.revert_version')}
                              </a>
                            </div>
                          </div>
                        ) : null
                      }
                      <div className="component_versions_box">
                        <table className="table bottom_box">
                          <tbody>
                            <tr>
                              <td>
                                <div className="table_wrap table_type_3">
                                  {this.renderDetailInfo()}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </Scrollbars>
              </div>
            )
          }
        </div>
        <SecurityDetailModal
          isOpenMSD={isOpenMSD}
          closeModal={this.handleMSDClose}
          cveData={cveData}
          selectedCode={selectedCode}
        />
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(ComponentVersionModal)));
